import { Injectable } from "@angular/core";
import { IGeofence } from "@app/interfaces/IGeofences";
import { ILocationInformation } from "@app/interfaces/ILocationInformation";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GeocodeService } from "../geocode.service";
import { GeofenceService } from "../geofence.service";

@Injectable({
    providedIn: 'root'
})
export class LocationInformationService {

    constructor(
        private readonly geocodeService: GeocodeService,
        private readonly geofenceService: GeofenceService) {
    }

    getAllGeofences(): Promise<IGeofence[]> {
        return this.geofenceService.getGeofences({ unsafe: true }) as Promise<IGeofence[]>;
    }

    async getGeofenceName(id: number, includeAddress?: boolean): Promise<string> {
        const geofences = await this.getAllGeofences();
        const geofence: IGeofence = geofences.find(geofence => geofence.Id === id);

        if (!geofence) {
            return "N/A";
        }

        let geofenceName = includeAddress ?
            `${geofence.Description} - ${geofence.Addr1}, ${geofence.Addr2}` :
            geofence.Description;

        return await geofenceName;
    }

    async getGeofenceNamesString(locationInformation: ILocationInformation, includeAddress = false): Promise<string> {
        if (!locationInformation?.GeofenceIds?.length) {
            return "N/A";
        }

        const geofenceNamePromises = locationInformation.GeofenceIds.map(gId =>
            this.getGeofenceName(gId, includeAddress)
        );

        const geofenceNames = await Promise.all(geofenceNamePromises);

        return geofenceNames.join(', ');
    }

    getPlotLocation(plotId: number): Observable<ILocationInformation> {
        return from(this.geocodeService.getLocationInformationFromPlotId(plotId) as Promise<ILocationInformation>).pipe(
            map((locationInformation: ILocationInformation) => {
                if (!locationInformation) {
                    return {
                        GeofenceIds: [],
                        LocationDescription: "N/A"
                    }
                }
                return locationInformation;
            }))
    }

    getLocationInformationFromLatLng(latLng: google.maps.LatLng): Observable<ILocationInformation> {
        return from(this.geocodeService.getLocationInformationFromLatLong(latLng)).pipe(
            map((locationInformation: ILocationInformation) => {
                if (!locationInformation) {
                    return {
                        GeofenceIds: [],
                        LocationDescription: "N/A"
                    }
                }
                return locationInformation;
            })
        )
    }
}
